import { render, staticRenderFns } from "./LoyaltyLevelOverviewMobilePreview.vue?vue&type=template&id=18054235&scoped=true&"
import script from "./LoyaltyLevelOverviewMobilePreview.vue?vue&type=script&lang=js&"
export * from "./LoyaltyLevelOverviewMobilePreview.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyLevelOverviewMobilePreview.vue?vue&type=style&index=0&id=18054235&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18054235",
  null
  
)

export default component.exports